export default {
    Get: {
        GET_LARGEMAILING:'getLargeMailing',
        CHANGE_INFO_LARGEMAILING: 'changeInfoLargeMailing',
        DEMAND_INFOS: 'getDemandInfo',
        PERSON_INFOS: 'getPersonInfo',
        INVALID_EMAILS: 'getInvalidPersonEmails'
    },
    Set: {
        INIT_LARGEMAILING: 'initLargeMailing',
        STORE_LARGEMAILING: 'insertLargeMailing',
        UPDATE_LARGEMAILING: 'updateLargeMailing',
        UPDATE_iTEM_ARRAY_FIELD_LARGEMAILING: 'updateArrayFieldLargeMailing',
        // PUSH_iTEM_ARRAY_FIELD_LARGEMAILING: 'pushItemToArrayFieldLargeMailing',
        REMOVE_ITEM_ARRAY_FIELD_LARGEMAILING: 'removeItemToArrayFieldLargeMailing',
        DELETE_LARGEMAILING: 'deleteLargeMailing',
        POST_DATA_LARGEMAILING: 'postDataLargeMailing',
        DEMAND_INFOS: 'setDemandInfos',
        PERSON_INFOS: 'setPersonInfo'
    },
    Service: {
        CHANGE_INFO_LARGEMAILING: 'changeInfoLargeMailing', //{info} (INIT, MEDIA, USER, PROPERTY, MESSAGE) 
        SEND_LARGEMAILING: 'sendLargeMailing',
        CHECK_STATUS_LARGEMAILING: 'sendLargeMailing',
        GET_INVALID_PERSON_EMAILS: 'getInvalidPersonEmails'
    }
};